import {
	Box,
	ButtonGroup,
	FormControl,
	FormLabel,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Select,
	Text,
} from '@chakra-ui/react';
import { IconRefreshAlert } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import { useCalculateAverageTicket } from 'pages/admin/demand/averageTicket/hooks/useCalculateAverageTicket';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import { useState } from 'react';
import { ICompanyParameterization } from 'services/api/requests/company';
import { useGetCompanyParameterization } from 'services/queryClient/wrapperHooks/companyConfigs/useGetCompanyParameterization';

const generateOptions = (
	value: number,
	parameterization?: ICompanyParameterization
) => {
	return (
		<option value={value}>
			{value} {value === 1 ? 'mês' : 'meses'}
			{parameterization?.tamanho_rateio_ticket === value
				? '(Padrão)'
				: ''}
		</option>
	);
};
export const RecalculateAverageTicketModal = props => {
	const { isOpen, onClose } = props;

	const [intervaloTempo, setIntervaloTempo] = useState<string | number>('');

	const { mutate: RecalculateAverageTicket } =
		useCalculateAverageTicket(intervaloTempo);
	const { data: parameterization } =
		useGetCompanyParameterization(setIntervaloTempo);

	const handleActionButtonRecalculate = () => {
		RecalculateAverageTicket();
		onClose();
	};

	const [monthsOptions] = useState([1, 2, 3, 4, 5, 6, 9, 12]);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size={'2xl'}
			isCentered
		>
			<ModalOverlay />
			<ModalContent borderRadius={'3xl'}>
				<ModalHeader>
					<Icon
						as={IconRefreshAlert}
						color={'easyRED.300'}
						boxSize={14}
					/>
					<Text
						fontWeight={700}
						color={'easyBLUE.300'}
						fontSize={'2xl'}
					>
						{
							averageTicketMessages.SCREEN_TITLES
								.RECALCULATE_AVERAGE_TICKET
						}
					</Text>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box mb={6}>
						<Text
							color={'secondaryGray.500'}
							fontWeight={400}
							fontSize={'md'}
						>
							{averageTicketMessages.MSG_RECALCULATE_DESCRIPTION}
						</Text>
					</Box>
					<FormControl>
						<FormLabel color={'easyBLUE.300'}>
							<Text pb={2.5}>
								{averageTicketMessages.LABELS.TIME_INTERVAL}
							</Text>
							<Select
								data-test='select-intervalo_de_tempo-modal-preco_medio'
								onChange={e =>
									setIntervaloTempo(e.target.value)
								}
								value={intervaloTempo}
							>
								<option disabled>
									{
										averageTicketMessages.LABELS
											.SELECT_TIME_INTERVAL
									}
								</option>
								{monthsOptions.map(month => {
									return generateOptions(
										month,
										parameterization
									);
								})}
								<option value=''>
									{averageTicketMessages.LABELS.FULL_HISTORY}
								</option>
							</Select>
						</FormLabel>
					</FormControl>
				</ModalBody>

				<ModalFooter>
					<ButtonGroup>
						<ButtonComponent
							data-test={'button-cancelar-modal-preco_medio'}
							type={'ghost'}
							title={averageTicketMessages.LABELS.CANCEL_BUTTON}
							onClick={onClose}
						/>
						<ButtonComponent
							data-test={'button-confirmar-modal-preco_medio'}
							type={'secondary'}
							title={averageTicketMessages.LABELS.CONFIRM_BUTTON}
							onClick={handleActionButtonRecalculate}
						/>
					</ButtonGroup>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
